import mediator from "@tvg/mediator";

export const betSlipUndoGTMEvent = () => {
  mediator.base.dispatch({ type: "BETSLIP:UNDO" });
};
